import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
    const navigate = useNavigate();
    const { exchangeSession } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Use ref to prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processCallback = async () => {
            try {
                // Extract session_id from URL hash
                const hash = window.location.hash;
                const params = new URLSearchParams(hash.substring(1));
                const sessionId = params.get('session_id');

                if (!sessionId) {
                    console.error('No session_id in callback');
                    navigate('/login', { replace: true });
                    return;
                }

                // Exchange session_id for session_token
                const user = await exchangeSession(sessionId);
                
                // Clear the hash from URL
                window.history.replaceState(null, '', window.location.pathname);
                
                // Navigate to dashboard with user data
                navigate('/dashboard', { 
                    replace: true,
                    state: { user }
                });
            } catch (error) {
                console.error('Auth callback error:', error);
                navigate('/login', { replace: true });
            }
        };

        processCallback();
    }, [exchangeSession, navigate]);

    return (
        <div className="min-h-screen bg-gradient-hero flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
                <p className="font-ui text-lg text-foreground">Unlocking the Codex...</p>
                <p className="font-ui text-sm text-muted-foreground mt-2">Please wait while we verify your identity</p>
            </div>
        </div>
    );
};

export default AuthCallback;
